<template>
    <Header id="nav" style="">
        <div style="display: flex;">
            <router-link to="/" style="" class="mainlink">
              <img  style="height: 100%;" src="@/assets/Logo_ZZAgentur.svg" alt="">
<!--                <div style="margin-left: 10px;">-->
<!--                    <span v-html="getRoute()"></span>&nbsp;&nbsp;&nbsp;-->
<!--                </div>-->
            </router-link>
        </div>
        <div class="mainmenu d-flex" style="align-items: center">

            <div class="d-none d-md-flex">

                <router-link to="/ueberuns/marken-kommunikation" :class="{'active':slides}">Über uns</router-link>
                <router-link to="/leistungen">Leistungen</router-link>
                <router-link to="/themen">Themen</router-link>

                <router-link to="/kontakt">Kontakt</router-link>
                &nbsp;
                <a :class="{'active':refs||singleRef}" @click="openRefs">Arbeiten</a>
            </div>
            <div class="openline " style="cursor: pointer;" @click="openSub">
                &nbsp;<svg width="6" height="26" viewBox="0 0 6 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0H6V6H0V0Z" fill="#4D4D4D"/>
                <path d="M0 10H6V16H0V10Z" fill="#4D4D4D"/>
                <path d="M0 20H6V26H0V20Z" fill="#4D4D4D"/>
            </svg>
            </div>
        </div>
    </Header>
</template>
<script>
    import store from '@/store'

    export default {
        store,
        name: 'Menu',
        data() {
            return {}
        },
        created: function () {
        },
        props: {
            refs: Boolean,
            sub: Boolean
        },
        methods: {
            getRoute() {
                if (this.$route.meta.singleRef) return "Arbeiten"
                else return "Agentur"
            },
            openRefs() {
                this.$emit('update:refs', true)
            },
            openSub() {
                this.$emit('update:sub', !this.sub)
            }
        },
        watch: {
            '$route.path': function () {
                this.$emit('update:sub', false)            },
        },
        computed: {
            singleRef: function () {
                return this.$route.meta.singleRef
            }, slides: function () {
                return this.$route.meta.slides
            },
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" scoped>
    #nav {
        height: 72px;
        padding: 0;
        top: 0;
        display: flex;
        background-color: hsla(0,0%,100%,.95);        position: fixed;
        width: 100%;
        justify-content: space-between;
        /*opacity: 0.85;*/
        z-index: 1000000;
        backdrop-filter: blur(10px);

        /*filter: blur(4px);*/
    }

    .openline {
        align-self: center;
        padding-left: 100px;
        padding-right: 20px;
        margin-bottom: 6px;
      display: none;
      @include mobile {
        display: block;
      }


        &:hover {
            path {
                fill: $zzcolor;
            }
        }
    }

    .mainlink {
        display: flex;
        align-items: center;
        padding-left: 100px;
        @include mobile {
            padding-left: 20px;
        }
    }

    a {
        font-weight: 500;
        letter-spacing: 0.1em;
        color: $zzgray;
        margin: 20px 10px 10px;
        padding-bottom: 10px;
        line-height: 140%;
        font-size: 16px;
        text-transform: uppercase;
        cursor: pointer;

        &:hover {
            text-decoration: none;
        }
    }

    .mainmenu {
        /*height: calc(100% - 2px);*/
        padding-right: 10px;

        a {
            /*align-self: stretch;*/
            padding: 23px 0;
            border-bottom: 4px solid transparent;
            margin: 0px 20px 0;
            &:hover {
                color: $zzcolor;
            }
        }

        .router-link-exact-active, .active {
            color: $zzcolor;
            border-bottom: 4px solid $zzcolor;
        }
    }
</style>
